var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1087_25235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8177 6.04688H20.1615V3.51562C20.1615 1.57711 18.5844 0 16.6459 0H8.02087C6.08236 0 4.50525 1.57711 4.50525 3.51562V6.04688H3.849C1.91048 6.04688 0.333374 7.62398 0.333374 9.5625V15.1875C0.333374 17.126 1.91048 18.7031 3.849 18.7031H4.50525V21.8906C4.50525 23.0537 5.45151 24 6.61462 24H18.0521C19.2152 24 20.1615 23.0537 20.1615 21.8906V18.7031H20.8177C22.7563 18.7031 24.3334 17.126 24.3334 15.1875V9.5625C24.3334 7.62398 22.7563 6.04688 20.8177 6.04688ZM5.9115 3.51562C5.9115 2.35252 6.85776 1.40625 8.02087 1.40625H16.6459C17.809 1.40625 18.7552 2.35252 18.7552 3.51562V6.04688H5.9115V3.51562ZM18.7552 21.8906C18.7552 22.2783 18.4398 22.5938 18.0521 22.5938H6.61462C6.22692 22.5938 5.9115 22.2783 5.9115 21.8906V14.9531H18.7552V21.8906ZM22.9271 15.1875C22.9271 16.3506 21.9809 17.2969 20.8177 17.2969H20.1615V14.9531H20.5834C20.9717 14.9531 21.2865 14.6383 21.2865 14.25C21.2865 13.8617 20.9717 13.5469 20.5834 13.5469H4.08337C3.69506 13.5469 3.38025 13.8617 3.38025 14.25C3.38025 14.6383 3.69506 14.9531 4.08337 14.9531H4.50525V17.2969H3.849C2.68589 17.2969 1.73962 16.3506 1.73962 15.1875V9.5625C1.73962 8.39939 2.68589 7.45312 3.849 7.45312H20.8177C21.9809 7.45312 22.9271 8.39939 22.9271 9.5625V15.1875Z",
    fill: "#666E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2084 16.5469H10.4584C10.0701 16.5469 9.75525 16.8617 9.75525 17.25C9.75525 17.6383 10.0701 17.9531 10.4584 17.9531H14.2084C14.5967 17.9531 14.9115 17.6383 14.9115 17.25C14.9115 16.8617 14.5967 16.5469 14.2084 16.5469Z",
    fill: "#666E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2084 19.5469H10.4584C10.0701 19.5469 9.75525 19.8617 9.75525 20.25C9.75525 20.6383 10.0701 20.9531 10.4584 20.9531H14.2084C14.5967 20.9531 14.9115 20.6383 14.9115 20.25C14.9115 19.8617 14.5967 19.5469 14.2084 19.5469Z",
    fill: "#666E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33337 9.04688H4.08337C3.69506 9.04688 3.38025 9.36169 3.38025 9.75C3.38025 10.1383 3.69506 10.4531 4.08337 10.4531H6.33337C6.72169 10.4531 7.0365 10.1383 7.0365 9.75C7.0365 9.36169 6.72169 9.04688 6.33337 9.04688Z",
    fill: "#666E7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1087_25235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.e39f31fd8575a2f856c57756d16654ec.svg";
export { ForwardRef as ReactComponent };